import React from 'react'
import Footer from '../components/Common/Footer'
import { Form } from '../components/Contact/Form'
import Header from '../components/Contact/Header'
import Mail from '../components/Contact/Mail'
import Navbar from '../components/Navbar'

const Contact = () => {
  return (
    <div>
        <Navbar/>
        <Header/>
        <Mail/>
        <Form/>
        <Footer/>
    </div>
  )
}

export default Contact